import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = ["id"]

import { computed, onMounted, ref, toRaw, toRef, watch } from 'vue';
import axios from 'axios';
import Dropdown, { DropdownFilterEvent } from 'primevue/dropdown';
import AutoComplete from 'primevue/autocomplete';
import { MethodResult } from '@/models/MethodResult.model';
import { useField } from 'vee-validate';


export default /*#__PURE__*/_defineComponent({
  __name: 'LazyDropdown',
  props: {
    name: {},
    modelValue: {},
    url: {},
    requiredMessage: {},
    size: { default: 100 },
    placeholder: { default: 'Nhập tên trường hoặc mã trường để tìm kiếm' },
    optionLabel: { default: 'text' },
    optionValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;





const items = ref<any[]>([]);
const loading = ref(false);
const keyword = ref('');
const page = ref(1);

// const innerModel = computed({
//     get: () => props.modelValue,
//     set: (val) => {
//         console.log(val);
//         emit('update:modelValue', toRaw(val));
//     }
// });

// const onFilter = (event: DropdownFilterEvent) => {
//     console.log(event);
//     keyword.value = event.value;
//     page.value = 1;
//     items.value = [];
//     // fetchDataAsync();
// }

// const onLazyLoad = (event: { first: any; last: any; }) => {
//     console.log(event);
//     if (event.last >= items.value.length) {
//         page.value++;
//         fetchDataAsync(null);
//     }
// }
const search = (event: any) => {
    fetchDataAsync(event.query);
}

const fetchDataAsync = async (keyword: string = "") => {
    loading.value = true;
    const response = await axios.get<MethodResult<any[]>>(`${props.url}?keyword=${keyword}&page=1&pageSize=${props.size}`);
    const data = response.data.data;
    if (data && data.length) {
        const _items: any[] = [];
        data.forEach((item: any) => {
            _items.push(item);
        });
        items.value = _items;
    }
    loading.value = false;
}
const { errorMessage, value: innerModel } = useField<string>(toRef(props, 'name'), undefined, {
    initialValue: props.modelValue
});
onMounted(() => {
    fetchDataAsync();
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(AutoComplete), {
      modelValue: _unref(innerModel),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(innerModel) ? (innerModel).value = $event : null)),
      suggestions: items.value,
      onComplete: search,
      "option-label": _ctx.optionLabel,
      placeholder: _ctx.placeholder,
      inputClass: { 'w-full': true, 'p-invalid': _unref(errorMessage) },
      class: "w-full",
      forceSelection: ""
    }, null, 8, ["modelValue", "suggestions", "option-label", "placeholder", "inputClass"]),
    _createElementVNode("div", null, [
      _createElementVNode("small", {
        id: `${_ctx.name}-help`,
        class: "p-error"
      }, _toDisplayString(_unref(errorMessage) ? _ctx.requiredMessage : ''), 9, _hoisted_2)
    ])
  ]))
}
}

})